import { c as _c } from "react/compiler-runtime";
// «Открыть спор» по отклонённой заявке. Отдельного кадра в макете нет — форма
// собрана из деталей модалки «Заявка на возврат» (те же поля комментария и
// загрузки фото, те же кнопки), чтобы не выпадать из визуального языка.
import { Loader2, X } from "lucide-react";
import { useRef, useState } from "react";
import { toast } from "sonner";
import { api, type ReturnAttachment } from "@/api";
import { Download16Icon } from "@/components/icons";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { CabinetModal, Thumb } from "./return-parts";
const MAX_MEDIA = 10;
export function ReturnDisputeModal(t0) {
  const $ = _c(7);
  const {
    returnId,
    onOpenChange,
    onOpened
  } = t0;
  const t1 = Boolean(returnId);
  let t2;
  if ($[0] !== onOpened || $[1] !== returnId) {
    t2 = returnId ? <DisputeForm key={returnId} returnId={returnId} onOpened={onOpened} /> : null;
    $[0] = onOpened;
    $[1] = returnId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onOpenChange || $[4] !== t1 || $[5] !== t2) {
    t3 = <CabinetModal open={t1} onOpenChange={onOpenChange} title={"\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0441\u043F\u043E\u0440"}>{t2}</CabinetModal>;
    $[3] = onOpenChange;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function DisputeForm({
  returnId,
  onOpened
}: {
  returnId: string;
  onOpened: () => void;
}) {
  const [comment, setComment] = useState("");
  const [media, setMedia] = useState<ReturnAttachment[]>([]);
  const [uploading, setUploading] = useState(false);
  const [sending, setSending] = useState(false);
  const fileRef = useRef<HTMLInputElement>(null);
  const ready = comment.trim().length > 0 && !uploading;
  const upload = async (files: FileList | null) => {
    if (!files?.length) return;
    setUploading(true);
    try {
      for (const file of Array.from(files).slice(0, MAX_MEDIA - media.length)) {
        const att = await api.cabinet.uploadReturnAttachment(file);
        setMedia(prev => [...prev, att]);
      }
    } catch (e) {
      toast.error(e instanceof Error ? e.message : "Не удалось загрузить файл");
    } finally {
      setUploading(false);
      if (fileRef.current) fileRef.current.value = "";
    }
  };
  const submit = async () => {
    setSending(true);
    try {
      await api.cabinet.openDispute(returnId, {
        comment: comment.trim(),
        attachmentIds: media.map(m => m.id)
      });
      toast.success("Спор открыт — площадка подключится к разбору");
      onOpened();
    } catch (e_0) {
      toast.error(e_0 instanceof Error ? e_0.message : "Не удалось открыть спор");
    } finally {
      setSending(false);
    }
  };
  return <div className="flex flex-col">
			<p className="text-[14px] leading-[18px] text-ds-primary">
				Продавец отклонил заявку. Опишите, с чем вы не согласны, — спор рассмотрит площадка.
			</p>
			<label className="mt-4 text-[16px] leading-5 font-semibold tracking-[-0.31px] text-ds-primary" htmlFor="dispute-comment">
				Комментарий
			</label>
			<Textarea id="dispute-comment" value={comment} onChange={e_1 => setComment(e_1.target.value)} maxLength={2000} rows={3} placeholder="Почему вы не согласны с решением продавца" className="mt-2 min-h-[88px] resize-none" />
			<p className="mt-4 text-[16px] leading-5 font-semibold tracking-[-0.31px] text-ds-primary">
				Фото и видео ({media.length}/{MAX_MEDIA})
			</p>
			{media.length > 0 ? <div className="mt-2 flex flex-wrap gap-1">
					{media.map(m_0 => <span key={m_0.id} className="relative">
							<Thumb src={m_0.thumbnailUrl || m_0.url} w={40} h={53} />
							<button type="button" aria-label="Убрать файл" onClick={() => setMedia(prev_0 => prev_0.filter(x => x.id !== m_0.id))} className="absolute -top-1 -right-1 grid size-4 place-items-center rounded-full bg-[#2E2E2E] text-white">
								<X className="size-3" />
							</button>
						</span>)}
				</div> : null}
			<input ref={fileRef} type="file" accept="image/*,video/*" multiple hidden onChange={e_2 => void upload(e_2.target.files)} />
			<Button variant="gray" size="md" disabled={uploading || media.length >= MAX_MEDIA} onClick={() => fileRef.current?.click()} className="mt-3 self-start">
				{uploading ? <Loader2 className="size-4 animate-spin" /> : <Download16Icon size={16} />}
				Загрузить фото
			</Button>
			<Button block disabled={!ready || sending} onClick={() => void submit()} className="mt-5">
				{sending ? "Отправляем…" : "Открыть спор"}
			</Button>
		</div>;
}